import React from 'react';
import PropTypes from 'prop-types';
import Icon from 'components/Utils/NewIcon';
import { useAppSelector } from 'careand-redux/store';
import StaffUtils from 'services/StaffUtils';
import PatientUtils from 'services/PatientUtils';

const CPPTimelineCommunicationNote = ({ note }) => {
  const admins = useAppSelector((state) => state.admins.byId);
  const physicians = useAppSelector((state) => state.physicians.byId);
  const patients = useAppSelector((state) => state.patients.byId);

  const staff = admins[note.staff_id] || physicians[note.staff_id];
  const staffPatient = patients[note.staff_id];

  let name = '';
  if (staff) {
    name = StaffUtils.getName(staff);
  } else if (staffPatient) {
    name = PatientUtils.getName(staffPatient, undefined, false);
  }

  if (name) name = ` by ${name}`;

  if (note.staff_id === note.patient_id) name = 'Patient';

  return (
    <div className="item-wrapper clickable" data-tip>
      <div className="top-bar">
        <Icon src="note" />
        <span className="small-title">Patient Comm.</span>
      </div>
      <div className="item-content">
        <span>
          {note.note} {name}
        </span>
      </div>
    </div>
  );
};

CPPTimelineCommunicationNote.propTypes = {
  note: PropTypes.object.isRequired,
};

export default CPPTimelineCommunicationNote;
